globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};
appCustomerSpace.Modules.Charts = appCustomerSpace.Modules.Charts || {};

appCustomerSpace.Modules.Charts.lang = {
  t: function(path) {
    var translation = undefined,
        pathArray = path.split('.');

    for(var i = 0; i < pathArray.length; i++) {
      translation = (translation || this)[pathArray[i]];

      if(!translation) break;
    }

    return translation || ('Missing translation for : ' + path);
  },
  commons: {
    seeMore: 'See more',
    seeLess: 'Hide all',
    seeAll: 'Show all',
    visitsNb: 'Nb of Visits'
  },
  highcharts: {
    months: ['January', 'February', 'March', 'April', 'May', 'June',  'July', 'August', 'September', 'October', 'November', 'December'],
    weekdays: ['Sunday', 'Monday', 'Tuesady', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    shortMonths : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  },
  periodRanges: {
    all: 'All',
    thisWeek: 'This week',
    lastWeek: 'Last week',
    twoWeeksAgo: '2 weeks ago',
    lastSemester: 'Last semester',
    beforeLastSemester: 'Before last semester'
  }
}
